export * from './chart-simple.component';
export * from './chart-smallpie.component';
export * from './chart-simple.module';



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/typescripts/pro/easy-charts/index.ts